import React from 'react';

const ComingSoon = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Coming Soon!</h1>
            <p style={styles.subtitle}>
                We're working hard to bring you something amazing. Stay tuned!
            </p>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '20px',
    },
    title: {
        fontSize: '3rem',
        margin: '0 0 10px',
    },
    subtitle: {
        fontSize: '1.5rem',
        margin: '0 0 40px',
        maxWidth: '600px',
    },
};

export default ComingSoon;
